<template>
    <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
    name: 'master-supplierSet',
    components: {
        PageTable,
    },
}
</script>
